import { PositionResource, useInventoryCommon } from '@eih-netbroker/common';
import { useMemo } from 'react';
import { Config } from '../../config/config';
import { useLogger } from '../../utils/useLogger';
import { useEStream } from '../sse/useEStream';
import { useInstrumentSearch } from '../useInstrumentSearch';
import { useResource, useResourceHeaders } from '../useResource';

export const useInventory = () => {
  const logger = useLogger(`useInventory`);
  const positionResource = useResource(PositionResource);
  const { getResourceHeaderWithToken } = useResourceHeaders();
  const { getListedInstrumentList } = useInstrumentSearch();
  const { loadInstrument, getExchangeRate } = useEStream();

  const p = useMemo(
    () => ({
      config: Config,
      getListedInstrumentList,
      logger,
      positionResource,
      getResourceHeaderWithToken,
      loadInstrument,
      getExchangeRate,
    }),
    [getListedInstrumentList, logger, positionResource, getResourceHeaderWithToken, loadInstrument, getExchangeRate],
  );

  return useInventoryCommon(p);
};
